"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dataStoring_1 = require("@common/services/dataStoring");
var moderationQueue_1 = require("@common/services/moderationQueue");
var ApolloErrorMessage_1 = require("@components/ApolloErrorMessage");
var OverallList_1 = __importDefault(require("@features/ItemLogPage/components/OverallList"));
var SearchBar_1 = require("@features/ItemLogPage/components/SearchBar");
var fromDateUtil_1 = require("@features/ItemLogPage/util/fromDateUtil");
var querryUtil_1 = require("@features/ItemLogPage/util/querryUtil");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var searchDocumentV2_1 = require("@/react-app/common/services/searchDocumentV2");
var constants_1 = require("./util/constants");
// const getTimeStamp = () => {
//   const timestamp = new Date();
//   // get ads that are created 10 seconds ago, to ensure that they are probably processed and searchable
//   timestamp.setSeconds(timestamp.getSeconds() - 10);
//   return timestamp;
// };
function default_1(_a) {
    var domain = _a.domain, filterId = _a.filterId, filterViewDefaultStartDate = _a.filterViewDefaultStartDate, angularJsDependencies = _a.angularJsDependencies;
    var _b = (0, moderationQueue_1.useGetQueuesQuery)(domain), queuesData = _b.data, queuesError = _b.error, refetchQueues = _b.refetch;
    var _c = (0, dataStoring_1.useGetDataStoringOptionQuery)(domain), storingOpt = _c.data, storingOptError = _c.error, refetchOptions = _c.refetch;
    var t = (0, react_i18next_1.useTranslation)().t;
    var minDate = (0, react_1.useMemo)(function () {
        if (storingOpt) {
            return (0, fromDateUtil_1.minDateFromPeriod)(storingOpt.period);
        }
        return null;
    }, [storingOpt]);
    var refetchData = function () {
        refetchOptions();
        refetchQueues();
    };
    var memoizedAngularJsDependencies = (0, react_1.useMemo)(function () { return angularJsDependencies; }, []);
    if (queuesData && storingOpt && minDate != null && !queuesError && !storingOptError) {
        return (react_1.default.createElement(ItemLogSub, { domain: domain, filterId: filterId, filterViewDefaultStartDate: filterViewDefaultStartDate, angularJsDependencies: memoizedAngularJsDependencies, minDate: minDate }));
    }
    return (react_1.default.createElement("div", { className: "row" },
        react_1.default.createElement("div", { className: "col-md-12" },
            react_1.default.createElement("div", { className: "empty-ng-table" },
                react_1.default.createElement(ApolloErrorMessage_1.ApolloErrorMessage, { error: queuesError || storingOptError, title: t('itemLog:TABLE.TEXT.HAS_ERROR'), refetchData: refetchData, tryAgainText: t('itemLog:TABLE.BUTTON.TRY_AGAIN') })))));
}
exports.default = default_1;
function ItemLogSub(_a) {
    var domain = _a.domain, filterId = _a.filterId, filterViewDefaultStartDate = _a.filterViewDefaultStartDate, angularJsDependencies = _a.angularJsDependencies, minDate = _a.minDate;
    var t = (0, react_i18next_1.useTranslation)().t;
    var statuses = querryUtil_1.STATUSES.map(function (status) { return (__assign(__assign({}, status), { label: t(status.label) })); });
    var decisionResultTypes = [
        { id: 'auto', label: t('DASHBOARD.ITEM_LOG.DECISION_TYPE.AUTO'), prefix: 'metadata.automaticResults.result' },
        { id: 'manual', label: t('DASHBOARD.ITEM_LOG.DECISION_TYPE.MANUAL'), prefix: 'metadata.manualResults.result' },
        { id: 'remote', label: t('DASHBOARD.ITEM_LOG.DECISION_TYPE.REMOTE'), prefix: 'metadata.clientResults.result' },
    ];
    var defaultsSearchParams = {
        perPage: 20,
        order: 'DESC',
        sort: 'metadata.created',
        from: minDate,
        to: undefined,
        domain: domain,
        filterId: filterId,
        id: '',
        currentPage: 0,
    };
    var urlParams = new URLSearchParams(window.location.search);
    var _b = __read(react_1.default.useState((0, querryUtil_1.getQueryFromUrlParams)(defaultsSearchParams, urlParams, statuses)), 2), searchParams = _b[0], setSearchParams = _b[1];
    var queuesData = (0, moderationQueue_1.useGetQueuesQuery)(domain).data;
    var displayQueue = (0, react_1.useMemo)(function () {
        var _a;
        var statusId = ((_a = searchParams === null || searchParams === void 0 ? void 0 : searchParams.status) === null || _a === void 0 ? void 0 : _a.id) || false;
        return ['MANUAL', 'DEFER'].some(function (value) { return value === statusId; });
    }, [searchParams]);
    var _c = __read(react_1.default.useState(searchParams.id || ''), 2), searchInputValue = _c[0], setSearchInputValue = _c[1];
    var _d = __read(react_1.default.useState(null), 2), searchTimestamp = _d[0], setSearchTimestamp = _d[1];
    var defaultStartDate = (0, react_1.useMemo)(function () { return (filterViewDefaultStartDate ? new Date(filterViewDefaultStartDate) : constants_1.itemLogViewDefaultStartDate); }, [filterViewDefaultStartDate]);
    (0, react_1.useEffect)(function () {
        refreshTimestamp();
    }, []);
    // On every change we update the URL but not reload the page
    (0, react_1.useEffect)(function () {
        var newParams = (0, querryUtil_1.getUrlParametersFromOptions)(searchParams, defaultsSearchParams);
        if (filterId) {
            newParams = __assign(__assign({}, newParams), { filterId: filterId });
        }
        if (newParams.from) {
            var routeName = filterId ? 'app.assignment.automation.filterView' : 'app.assignment.overview.recentItems';
            var newRouteOpt = { notify: false, inherit: false, location: 'replace' };
            angularJsDependencies.go(routeName, newParams, newRouteOpt);
        }
    }, [searchParams, filterId]);
    var resetSearch = function () {
        var id = searchParams.id, status = searchParams.status, type = searchParams.type, filterId = searchParams.filterId, rest = __rest(searchParams, ["id", "status", "type", "filterId"]);
        setSearchParams(__assign(__assign({}, rest), { from: defaultStartDate || minDate, to: undefined, filterId: filterId, id: '' }));
        setSearchInputValue('');
        refreshTimestamp();
    };
    var refreshTimestamp = function () {
        var timestamp = new Date();
        // get ads that are created 10 seconds ago, to ensure that they are probably processed and searchable
        timestamp.setSeconds(timestamp.getSeconds() - 10);
        setSearchTimestamp(timestamp.toISOString());
    };
    var onSortOrderChange = function (order) {
        setSearchParams(__assign(__assign({}, searchParams), { order: order }));
    };
    var onPaginationChange = function (newPage) {
        setSearchParams(__assign(__assign({}, searchParams), { currentPage: newPage }));
    };
    // Compute the query to send
    var queryOptions = (0, react_1.useMemo)(function () {
        if (searchTimestamp && minDate) {
            return {
                domain: domain,
                sort: {
                    type: 'field',
                    field: 'metadata.created',
                    direction: searchParams.order,
                },
                pagination: {
                    page: searchParams.currentPage || 0,
                    size: searchParams.perPage || 10,
                },
                fullText: {
                    queryString: (0, querryUtil_1.queryBuilder)(searchParams, minDate || null, searchTimestamp, [], decisionResultTypes) || '',
                },
            };
        }
    }, [searchTimestamp, minDate, searchParams, domain]);
    // Compute the query for count request
    var countRequestQueryOption = (0, react_1.useMemo)(function () {
        var domain = searchParams.domain;
        return {
            domain: domain,
            fullText: (queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fullText) || { queryString: '' },
        };
    }, [searchTimestamp, minDate, searchParams, domain]);
    // instead of moving the logic in child component and conditionally render it when queryOptions is undefined => we use skip
    var skip = queryOptions === undefined;
    var _e = (0, searchDocumentV2_1.useSearchDocumentsQuery)(queryOptions, {
        skip: skip,
    }), data = _e.data, searchError = _e.error, firstRequestLoading = _e.isLoading, isFetching = _e.isFetching;
    var countData = (0, searchDocumentV2_1.useSearchDocumentsCountQuery)(countRequestQueryOption, {
        skip: skip,
    }).data;
    var total = (countData === null || countData === void 0 ? void 0 : countData.count) || 0;
    var transformedData = (data &&
        (0, searchDocumentV2_1.transformItemsResponseV2)(data, queuesData || [], searchParams.currentPage || 0, total, searchParams.perPage || 20)) ||
        searchDocumentV2_1.initialTransformedData;
    // Initially skip is true and we need to show the loading spinner
    var isLoading = skip || isFetching || firstRequestLoading;
    return (react_1.default.createElement("div", { "data-cy": "item-log" },
        queuesData && queryOptions && (react_1.default.createElement(SearchBar_1.SearchBar, { filterId: filterId, searchParams: searchParams, setSearchParams: setSearchParams, countRequestQueryOption: countRequestQueryOption, transformedData: transformedData, defaultStartDate: defaultStartDate || null, setSearchInputValue: setSearchInputValue, searchInputValue: searchInputValue, paginate: onPaginationChange, refreshTimestamp: refreshTimestamp, minDate: minDate, isLoading: isLoading })),
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-md-12" }, queryOptions && queuesData && (react_1.default.createElement(OverallList_1.default, { isLoading: isLoading, searchError: searchError, transformedData: transformedData, domain: domain, angularJsDependencies: angularJsDependencies, resetSearch: resetSearch, paginate: onPaginationChange, displayQueue: displayQueue, order: searchParams.order, onSortOrderChange: onSortOrderChange, minDate: minDate }))))));
}
